import axios from "axios";
import { config } from "../config";
import { ApiLoginRequest } from "../models/requests/ApiLoginRequest";
import { ApiAuthResult } from "../models/responses/ApiAuthResult";

const backendUrl = `${config.apiServerUrl}/auth`;

export const login = async (loginRequest: ApiLoginRequest): Promise<ApiAuthResult> => {
    try {
        const response = await axios.post(`${backendUrl}/login`, loginRequest, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return response.data;
    } catch (error: any) {
        if (error.response?.data) {
            return error.response.data;
        } else if (error.response?.status) {
            return {
                success: false,
                error: `Network error: ${error.response.status}`,
                message: error.response.statusText || 'Login failed'
            };
        } else {
            return {
                success: false,
                error: 'NetworkError',
                message: 'Unable to connect to server. Please check your internet connection.'
            };
        }
    }
};

export const logout = async (token?: string): Promise<void> => {
    try {
        const headers: any = {
            'Content-Type': 'application/json'
        };

        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }

        await axios.post(`${backendUrl}/logout`, {}, { headers });
        console.log('Logout successful');
    } catch (error) {
        console.error("Logout API error:", error);
    }
};

export const refreshToken = async (refreshToken: string): Promise<ApiAuthResult> => {
    try {
        const response = await axios.post(`${backendUrl}/refresh-token`, {
            refreshToken
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return response.data;
    } catch (error: any) {
        return {
            success: false,
            error: 'RefreshTokenFailed',
            message: 'Failed to refresh authentication token'
        };
    }
};

export const forgotPassword = async (model: any): Promise<any> => {
    try {
        const response = await axios.post(`${backendUrl}/forgot-password`, model, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return response.data;
    } catch (error) {
        console.error("Send password reset link API error:", error);
    }
};

export const resetPassword = async (model: any): Promise<any> => {
    try {
        const response = await axios.post(`${backendUrl}/reset-password`, model, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return response.data;
    } catch (error) {
        console.error("Reset password API error:", error);
    }
}